import React from "react";
import { CheckboxCore } from "./CheckboxCore";
import "./Checkbox.less";

interface Option {
   label: string;
   value: string;
   disabled?: boolean;
}

/**
 * Props for the CheckboxGroup component.
 * @typedef {Object} CheckboxGroupProps
 * @property {Option[]} options - The list of options to display in the checkbox group.
 * @property {string[]} [value] - The currently selected values.
 * @property {function} [onChange] - Function called when the checkbox selection changes.
 */
export interface CheckboxGroupProps {
   options: Option[];
   value?: string[];
   onChange?: (selectedValues: string[]) => void;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ options, value = [], onChange }) => {
   const handleChange = (optionValue: string, isChecked: boolean) => {
      if (onChange) {
         const newValue = isChecked
            ? [...value, optionValue]
            : value.filter((v) => v !== optionValue);
         onChange(newValue);
      }
   };

   return (
      <div>
         {options.map((option) => (
            <CheckboxCore
               className="checkbox-group"
               key={option.value}
               checked={value.includes(option.value)}
               disabled={option.disabled}
               onChange={(e) => handleChange(option.value, e.target.checked)}
            >
               {option.label}
            </CheckboxCore>
         ))}
      </div>
   );
};

export default CheckboxGroup;

//INFOOOOOOOOO
//use it like this:

// const [selectedValues, setSelectedValues] = useState([]);

// const options = [
//     { label: "Option 1", value: "1" },
//     { label: "Option 2", value: "2" },
//     { label: "Option 3", value: "3" }
//  ];

//  const handleCheckboxGroupChange = (values) => {
//     setSelectedValues(values);
//  };

//  <Checkbox.Group
// options={options}
// value={selectedValues}
// onChange={handleCheckboxGroupChange}
// />
